<modal-panel title="COGS Details" (close)="closeDialog()">
  <app-kt-cogs-detail [data]="data.id"></app-kt-cogs-detail>
  <ng-container modalPanelFooter>
    <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
  </ng-container>
</modal-panel>
